module.exports = __webpack_public_path__ + "img/ldg.13c7f3ce.jpg";